export default __webpack_public_path__ + "static/media/tc.2b7ec2be.jpg";